import { ApiService } from "./api.service";

const UserService = {
  /**
   * Login the user and store the access token to TokenService.
   *
   * @returns access_token
   * @throws AuthenticationError
   **/
  login: async function(user_code, password) {
    const requestData = {
      method: "post",
      url: "/auth",
      data: {
        user_code: user_code,
        password: password
      },
      auth: {
        user_code: process.env.VUE_APP_CLIENT_ID,
        password: process.env.VUE_APP_CLIENT_SECRET
      }
    };

    return await ApiService.customRequest(requestData);
  },

  /**
   * 
   * @returns current user
   */
  verify: async function() {
    return await ApiService.get('/auth/verify')
  },
  /**
   * Refresh the access token.
   **/
  refreshToken: async function() {
    const requestData = {
      method: "post",
      url: "/auth/refresh_token/",
    };

    return await ApiService.customRequest(requestData);
  },

  /**
   * Logout the current user by removing the token from storage.
   *
   * Will also remove `Authorization Bearer <token>` header from future requests.
   **/
  logout() {
    return ApiService.delete('/auth/logout')
  },
  userUpdateMyPassword(currentPassword, newPassword, newPasswordConfirm) {
    return ApiService.patch('/auth/account/updateMyPassword', { currentPassword, newPassword, newPasswordConfirm })
  },
  /**
   * get role by one
   * @returns an object
   */
  userGetOrCreate(user_code){
    return ApiService.post('/auth/user/r/c',{user_code});
  },
  /**
   * get role by one
   * @returns an object
   */
  userGetOne(user_code){
    return ApiService.get('/auth/user/'+user_code);
  },
  /** 
   * get user role list pagination
   * @returns array
   */
  userGetList(page, query){
    if (!page) page = 0;
    return ApiService.get('/auth/user/list/'+page,query);
  },

  /** 
   * update user role
   * @returns object updated
   */
  userUpdate(data){
    return ApiService.put('/auth/user',data);
  },

  userUpdatePassword(id, password, password1){
    return ApiService.patch(`/auth/user/${id}`,{password, password1});
  },

  /** 
   * delete user from temp
   * @returns object deleted
   */
  userRemoveTemp(tmp_user_code){ 
    return ApiService.delete('/auth/user/tmp/'+tmp_user_code);
  },   
  /** 
   * delete user from temp
   * @returns object deleted
   */
  userDelete(id){ 
    return ApiService.delete(`/auth/user/${id}`);
  },   
  /**
   * get role by one
   * @returns an object
   */
  userRoleGetOrCreate(role_code){
    return ApiService.post('/auth/role/r/c',{role_code});
  },
  /**
   * get role by one
   * @returns an object
   */
  userRoleGetOne(role_code){
    return ApiService.get(`/auth/role?role_code=${role_code}`);
  },
  /** 
   * get user role list pagination
   * @returns array
   */
  userRoleGetList(){
    return ApiService.get('/auth/role/list');
  },
  /** 
   * insert user role with default value
   * @returns object inserted
   */
  userRoleCreate(data){
    return ApiService.post('/auth/role',data);
  },

  /** 
   * update user role
   * @returns object updated
   */
  userRoleUpdate(data){
    return ApiService.put('/auth/role',data);
  },

  /** 
   * delete user role from temp
   * @returns object deleted
   */
  userRoleRemoveTemp(tmp_role_code){ 
    return ApiService.delete('/auth/role/tmp/'+tmp_role_code);
  },

  userRoleDelete(id){ 
    return ApiService.delete(`/auth/role/${id}`);
  },

  /** 
   * get user role list pagination
   * @returns array
   */
  userServiceAccessGetList: (page = 0, moduleName) => {
    return ApiService.get(`/auth/serviceAccess/list/?module=${moduleName}&page=${page}`);
  },
  
  roleAccess: (role_code) => {
    return ApiService.get(`/auth/role-access/${role_code}`)
  },

  getPermission: (file, action) => {
    return ApiService.get(`/auth/check-permission/${file}/${action}`)
  },

  getUserRoleUIPermissions: () => {
    return ApiService.get(`/auth/getUserRoleUIPermissions/`)
  }
};

export default UserService;

export { UserService };



// WEBPACK FOOTER //
// ./src/services/user.service.js